import { Component, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/service/auth.service';
import { EnvConfigurationService } from 'src/app/service/env-config.service';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  standalone: false,
})
export class AccountComponent implements OnInit {
  public accountUrl: string;

  constructor(
    public envService: EnvConfigurationService,
    private matDialogRef: MatDialogRef<AccountComponent>,
    public authService: AuthService
  ) {
    if (window.location.hostname === 'localhost') {
      this.accountUrl = this.envService.config.keycloakAccountUrl;
    } else {
      this.accountUrl = `${window.location.origin}/auth/realms/${envService.config.keycloakClientId}/account`;
    }
  }

  ngOnInit(): void {
    const matDialogConfig: MatDialogConfig = new MatDialogConfig();
    matDialogConfig.position = { right: '10px', top: '60px' };
    this.matDialogRef.updatePosition(matDialogConfig.position);
  }
}
